/*
 * @Author: your name
 * @Date: 2021-08-31 09:29:16
 * @LastEditTime: 2024-11-21 20:59:01
 * @LastEditors: bobo 350910378@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \baishu_react_ui\src\index.jsx
 */
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import i18n from "i18next";
// import axios from "axios";
import { get, post } from "./utils/http";
import { initReactI18next, useTranslation } from "react-i18next";
import langCN from "./language/zh_cn";
import langEN from "./language/en_us";
import langTW from "./language/zh_tw";
import cookie from "react-cookies";
import Promise from "promise";
import "./index.css";
import "./css/font-icon.css";
import "./css/font-icon-new.css";
import App from "./App";

import { BsyConfig } from "./global/BsyConfig";
import ErrorBoundary from "./utils/ErrorBoundary";

Object.freeze = function freeze(params) {
  return params;
};
if (!window.Promise) {
  window.Promise = Promise;
}

window.hasJarvisbim = window.lang_diy_mark == "jws" ? true : false; //贾维斯本地版状态

window.rootDirectroy = window.root_directroy;
if (window.root_directroy && window.root_directroy.indexOf("/") !== 0) {
  window.rootDirectroy = "/" + window.root_directroy;
}

// let userSelectMap = {};
// let deptSelectMap = {};
// let handler = {
//   set(target, key, value) {
//     if(key === "100000000000000000000001") debugger
//     console.log(`${key} set to ${value}`);
//     target[key] = value;
//     return true; // 表示成功
//   },
// };

// let handlerDept = {
//   set(target, key, value) {
//     if(key === "110000000000000000000001") debugger
//     console.log(`${key} set to ${value}`);
//     target[key] = value;
//     return true; // 表示成功
//   },
// };

window.userSelectMap = {}; // new Proxy(userSelectMap, handler);
window.deptSelectMap = {}; // new Proxy(deptSelectMap, handlerDept);

document.body.addEventListener("touchstart", function () { });

let language = cookie.load("bby_lang")
  ? cookie.load("bby_lang")
  : cookie.load("lang")
    ? cookie.load("lang")
    : window._bby_config.lang
      ? window._bby_config.lang
      : "zh_cn";
// console.log('language', language)

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them)
    resources: {
      en: {
        translation: langEN,
      },
      en_us: {
        translation: langEN,
      },
      zh: {
        translation: langCN,
      },
      zh_cn: {
        translation: langCN,
      },
      tw: {
        translation: langTW,
      },
      zh_tw: {
        translation: langTW,
      },
    },
    lng: language,
    fallbackLng: language,

    interpolation: {
      escapeValue: false,
    },
  });

function Main() {
  const { t, i18n  } = useTranslation();
  // console.log('Main lng', i18n.language)
  React.language = t;
  React.i18n = i18n; // 偷懒，图方便
  BsyConfig(); //初始化常量信息
  React.cookie = cookie;
  React.axios = post; //post 是已经封装过的axios接口 20210916
  React.axiosGet = get; // get模式

  // React.axios.defaults.headers.common['X-CSRF-Token'] = window.sitesetting.csrf_token;
  // React.axios.defaults.headers.common['FRAME-TYPE'] = "REACT";
  // document.title = (window._bby_config && window._bby_config.site) || window.title || React.language("template.test");
  return <App />;
}

let Loading = document.getElementById("Loading");
if (Loading) {
  if (Loading.hasOwnProperty("remove")) {
    Loading.remove();
  } else {
    Loading.parentNode.removeChild(Loading);
  }
}

document.getElementById("bby").style.zIndex = window.FX.STATIC.zIndex++;

ReactDOM.render(
  <ErrorBoundary>
    <BrowserRouter>
      <Main />
    </BrowserRouter>
  </ErrorBoundary>,
  document.getElementById("bby")
);
